import { SVGProps } from 'react';

export function CommentIcon({
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'css'>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5013_38436)">
        <path
          d="M23.9998 11.2476C23.8552 8.90758 23.029 6.66108 21.623 4.78499C20.2171 2.9089 18.2928 1.48526 16.0876 0.689559C13.8823 -0.106139 11.4923 -0.239103 9.21241 0.307059C6.93247 0.853221 4.86219 2.05463 3.2568 3.76318C1.65141 5.47173 0.581088 7.61273 0.177789 9.92222C-0.22551 12.2317 0.0558434 14.6088 0.987163 16.7603C1.91848 18.9118 3.45905 20.7438 5.41895 22.0303C7.37885 23.3169 9.6724 24.0018 12.0168 24.0006H18.9998C20.3255 23.9992 21.5965 23.472 22.5339 22.5346C23.4713 21.5972 23.9985 20.3262 23.9998 19.0006V11.2476ZM21.9998 19.0006C21.9998 19.7962 21.6838 20.5593 21.1212 21.1219C20.5586 21.6845 19.7955 22.0006 18.9998 22.0006H12.0168C10.6058 21.9999 9.21069 21.7019 7.92254 21.1259C6.6344 20.5499 5.48212 19.7088 4.54085 18.6576C3.59502 17.6068 2.88478 16.366 2.45774 15.0184C2.0307 13.6707 1.89675 12.2473 2.06485 10.8436C2.33028 8.62951 3.32504 6.56675 4.89229 4.98049C6.45954 3.39422 8.51015 2.37467 10.7208 2.08256C11.1521 2.02851 11.5862 2.00113 12.0208 2.00056C14.3513 1.99421 16.6097 2.80847 18.3998 4.30056C19.4454 5.16951 20.3036 6.24172 20.9224 7.45219C21.5412 8.66267 21.9078 9.9862 21.9998 11.3426V19.0006Z"
          fill="currentColor"
        />
        <path
          d="M7.99982 9H11.9998C12.265 9 12.5194 8.89464 12.7069 8.7071C12.8945 8.51957 12.9998 8.26521 12.9998 8C12.9998 7.73478 12.8945 7.48043 12.7069 7.29289C12.5194 7.10536 12.265 7 11.9998 7H7.99982C7.7346 7 7.48025 7.10536 7.29271 7.29289C7.10517 7.48043 6.99982 7.73478 6.99982 8C6.99982 8.26521 7.10517 8.51957 7.29271 8.7071C7.48025 8.89464 7.7346 9 7.99982 9Z"
          fill="currentColor"
        />
        <path
          d="M15.9998 11H7.99982C7.7346 11 7.48025 11.1054 7.29271 11.2929C7.10517 11.4804 6.99982 11.7348 6.99982 12C6.99982 12.2652 7.10517 12.5196 7.29271 12.7071C7.48025 12.8947 7.7346 13 7.99982 13H15.9998C16.265 13 16.5194 12.8947 16.7069 12.7071C16.8945 12.5196 16.9998 12.2652 16.9998 12C16.9998 11.7348 16.8945 11.4804 16.7069 11.2929C16.5194 11.1054 16.265 11 15.9998 11Z"
          fill="currentColor"
        />
        <path
          d="M15.9998 15H7.99982C7.7346 15 7.48025 15.1054 7.29271 15.2929C7.10517 15.4804 6.99982 15.7348 6.99982 16C6.99982 16.2652 7.10517 16.5196 7.29271 16.7071C7.48025 16.8947 7.7346 17 7.99982 17H15.9998C16.265 17 16.5194 16.8947 16.7069 16.7071C16.8945 16.5196 16.9998 16.2652 16.9998 16C16.9998 15.7348 16.8945 15.4804 16.7069 15.2929C16.5194 15.1054 16.265 15 15.9998 15Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_5013_38436">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
